<!--
 * @Description: 
 * @Author: 长老
 * @Date: 2019-09-05 11:32:32
 * @LastEditTime: 2020-03-18 11:45:51
 * @LastEditors: 陆伟
 -->
<template>
    <div id="share-cloud">
      <!-- 网络异常 -->
      <share-error ref="ShareError" v-if="isShowReload"></share-error>
      <!-- B方案 -->
      <div v-if="personalItem.aBtestId == 'coin_recommend_item_B'">
        <scheme-receive-b ref="schemeReceiveB" :personalItem="personalItem" :cloudData="cloudData" @showRegister="handleShowRegister"/>
      </div>
      <!-- A方案 -->
      <div v-if="personalItem.aBtestId == 'coin_recommend_item_A'">
        <scheme-receive-a ref="schemeReceiveA" :cloudData="cloudData" @showRegister="handleShowRegister" />
      </div>

      <!-- 注册 -->
      <RegisterBox ref="reqRef" @reloadPageInfo="reloadPageInfoFn" />

    </div>
</template>

<script type="text/ecmascript-6">
import YunJi from '@/assets/js/YunJi'
import * as Http from '@/pages/commodity/api/share'
import * as Util from '@/assets/js/Util'
import {doVanguardReport} from '@/assets/js/YJVanguard'
import wxShare from '../../common/wxShare'

import ShareError from '@/pages/commodity/components/ShareError'
import schemeReceiveA from '@/pages/commodity/views/ShareCloud/components/schemeReceiveA'
import schemeReceiveB from '@/pages/commodity/views/ShareCloud/components/schemeReceiveB'
import RegisterBox from '@/pages/commodity/components/RegisterBox/index'

export default {
  name: 'share-cloud',
  data() {
    return {
      shopId: YunJi.getUrlParams('shopId'),
      seqId: YunJi.getUrlParams('seqId') || '',
      shareConsumerId: YunJi.getUrlParams('shareConsumerId') || '',
      appCont: YunJi.getUrlParams('appCont') || 0,
      pageIndex: 0,
      pageSize: 20,
      personalItem: {},
      isShowReload: false
    }
  },
  components: { 
    ShareError, schemeReceiveB, schemeReceiveA, RegisterBox
  },
  beforeRouteEnter(to, from, next) {
    next()
  },
  beforeRouteLeave(to, from, next) {
    next()
  },
  activated() {
   
  },
  mounted() {
    this.getCouponShare()
  },
  methods: {
    handleShowRegister() {
      // 未注册手机号
      this.$refs.reqRef.showDialog()
    },
    // 注册成功回调 进行领取动作
    reloadPageInfoFn() {
      console.log('注册成功 reloadPageInfoFn')
      if(this.personalItem.aBtestId == 'coin_recommend_item_B') {
        this.$refs.schemeReceiveB.clickCloud()
      }

      if(this.personalItem.aBtestId == 'coin_recommend_item_A') {
        this.$refs.schemeReceiveA.clickCloud()
      }
    },
    // 获取基本信息
    getCouponShare() {
      return new Promise(() => {
        const params = {
          seqId: this.seqId,
          shopId: this.shopId,
          appCont: this.appCont,
          shareConsumerId: this.shareConsumerId
        }
        Http.getCouponShare(params).then((res) => {
          if (res.errorCode === parseFloat(Util.ERR_CODE)) {
            this.cloudData = res.data
            this.getPersonalItemByCoin()
            if (parseFloat(this.appCont) === 0) { // 微信H5调用分享数据
              wxShare({
                title: `${this.cloudData.shopName},给您发云币啦！`, // 分享的标题
                content: this.cloudData.content, // 分享的描述
                // 分享的url地址
                link: `${window.location.origin}${window.location.pathname}?seqId=${encodeURIComponent(this.seqId)}&shareConsumerId=${encodeURIComponent(this.shareConsumerId)}&shopId=${encodeURIComponent(this.shopId)}`, 
                imgUrl: this.cloudData.headUrl, // 默认分享图片
                callback: () => {
  
                }
              })
            }
            // 云集先锋 访客记录(小程序中单独处理了)
            if(this.appCont == 0) doVanguardReport('cloudCoin', this.shopId)
          } else if (res.errorCode !== 2418) {
            this.isShowReload = true // errorCode != 0 显示重新加载
          }
        }).catch(() => {
          this.isShowReload = true // errorCode != 0 显示重新加载
        })
      })
    },
    // 获取商品id，并判断是展示a页面还是b页面
    getPersonalItemByCoin() {
      const params = {
        shopId: this.shopId,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        consumerId: this.cloudData.consumerId,
        coinAmount: this.cloudData.couponMoney,
      }
      Http.getPersonalItemByCoin(params).then((res) => {
        if (res.errorCode === parseFloat(Util.ERR_CODE)) {
          this.personalItem = res.data
          // 埋点
          window.thinkingReport.track('page_load', {
            page_id: '00065',
            point_id: '21546',
            ABtestId: res.data.aBtestId,
          })
          // 埋点
          window.thinkingReport.track('others', {
            page_id: '00065',
            point_id: '21607',
            ABtestId: res.data.aBtestId,
            business_state: this.cloudData.type === 1 ? '领取成功' : this.cloudData.type === 2 ? '已抢完' : '已失效',
          })
        }
      })
    },
  }
}
</script>

<style>

</style>
